import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ICarePlan, IReference } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { ActionSheetController } from '@ionic/angular';
import { TranslatePipe } from '../../../shared/translate/pipes/translate.pipe';
import { ModalType } from '../../models/observation-definition.model';

@Component({
  selector: 'inc-care-plan-details',
  templateUrl: './care-plan-details.component.html',
  styleUrls: ['./care-plan-details.component.scss'],
})
export class CarePlanDetailsComponent extends AbstractDetailsComponent<ICarePlan> {
  @Input() modalType: ModalType;
  @Output() callAdd = new EventEmitter<{ componentName: string, modalType: ModalType }>();
  @Output() callUpdate = new EventEmitter<{ componentName: string, data: IReference, modalType: ModalType }>();
  @Output() callDelete = new EventEmitter<{ componentName: string, data: IReference }>();

  constructor(private actionSheetController: ActionSheetController, private translatePipe: TranslatePipe) {
    super();
  }

  add(componentName: string, modalType?: ModalType) {
    this.callAdd.emit({ componentName, modalType });
  }

  delete(componentName: string, data: IReference) {
    this.callDelete.emit({ componentName, data });
  }

  update(componentName: string, event: { data: IReference, modalType?: ModalType }) {
    this.callUpdate.emit({ componentName, data: event.data, modalType: event.modalType });
  }

  async openActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      buttons: [{
        text: this.translatePipe.transform('CUSTOM_ALERT'),
        icon: 'stats',
        handler: () => { this.add('supportingInfo', 'atomic'); }
      },
      {
        text: this.translatePipe.transform('TIME_SERIES_ALERT'),
        icon: 'clock',
        handler: () => { this.add('supportingInfo', 'aggregated'); }
      }]
    });
    await actionSheet.present();
  }

}
